import * as Types from '../../../generated/graphql_types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type NucleusModelListQueryVariables = Types.Exact<{
  limit: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type NucleusModelListQuery = {
  readonly __typename?: 'RootQuery';
  readonly viewer: { readonly __typename: 'ScaleUser'; readonly id: string } | null;
  readonly nucleusModelProjects: ReadonlyArray<{
    readonly __typename: 'NucleusModelProject';
    readonly id: string;
    readonly ref_id: string | null;
    readonly name: string;
    readonly is_public: boolean;
    readonly metadata: any | null;
    readonly bundle_name: string | null;
    readonly created_at: number | null;
    readonly tags: ReadonlyArray<string> | null;
    readonly trainedSliceIds: ReadonlyArray<string> | null;
    readonly evaluationsCount: number | null;
    readonly archived: boolean | null;
    readonly modelRuns: ReadonlyArray<{
      readonly __typename: 'NucleusModelRun';
      readonly id: string;
      readonly name: string | null;
      readonly metadata: any | null;
      readonly started_at: string;
      readonly status: string | null;
      readonly dataset: { readonly __typename?: 'NucleusDataset'; readonly name: string } | null;
    }> | null;
  }>;
};

export type ModelProjectFieldsFragment = {
  readonly __typename: 'NucleusModelProject';
  readonly id: string;
  readonly ref_id: string | null;
  readonly name: string;
  readonly is_public: boolean;
  readonly metadata: any | null;
  readonly bundle_name: string | null;
  readonly created_at: number | null;
  readonly tags: ReadonlyArray<string> | null;
  readonly trainedSliceIds: ReadonlyArray<string> | null;
  readonly evaluationsCount: number | null;
  readonly archived: boolean | null;
  readonly modelRuns: ReadonlyArray<{
    readonly __typename: 'NucleusModelRun';
    readonly id: string;
    readonly name: string | null;
    readonly metadata: any | null;
    readonly started_at: string;
    readonly status: string | null;
    readonly dataset: { readonly __typename?: 'NucleusDataset'; readonly name: string } | null;
  }> | null;
};

export const ModelProjectFieldsFragmentDoc = gql`
  fragment modelProjectFields on NucleusModelProject {
    __typename
    id
    ref_id
    name
    is_public
    metadata
    bundle_name
    created_at
    tags
    trainedSliceIds
    evaluationsCount
    archived
    modelRuns {
      __typename
      id
      name
      metadata
      started_at
      status
      dataset {
        name
      }
    }
  }
`;
export const NucleusModelListDocument = gql`
  query NucleusModelList($limit: Int) {
    viewer {
      __typename
      id
    }
    nucleusModelProjects(limit: $limit) {
      ...modelProjectFields
    }
  }
  ${ModelProjectFieldsFragmentDoc}
`;

export function useNucleusModelListQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusModelListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusModelListQuery, NucleusModelListQueryVariables>({
    query: NucleusModelListDocument,
    ...options,
  });
}
